import React from 'react';
import { styled } from 'styled-components';
import { DensityAwareImage } from './DensityAwareImage';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PlayImage = props => /*#__PURE__*/_jsx(ImageContainer, {
  ...props,
  children: /*#__PURE__*/_jsx(DensityAwareImage, {
    ...props
  })
});
const ImageContainer = ({
  aspectRatio,
  children,
  containerWidth,
  hasBorderRadius = true
}) => containerWidth ? /*#__PURE__*/_jsx(FixedSizeContainer, {
  hasBorderRadius: hasBorderRadius,
  style: {
    width: `${Math.round(containerWidth)}px`,
    height: calculateHeight(containerWidth, aspectRatio)
  },
  children: children
}) : /*#__PURE__*/_jsxs(ExpandContainer, {
  hasBorderRadius: hasBorderRadius,
  children: [/*#__PURE__*/_jsx(ExpandingElement, {
    style: {
      paddingBottom: getHeightPercentage(aspectRatio)
    }
  }), children]
});
export const aspectRatioMap = {
  '14/9': 14 / 9,
  '19/8': 19 / 8,
  '16/9': 1.777777778,
  '3/2': 1.5,
  '4/3': 1.333333333,
  '2/3': 0.666666667,
  '1/1': 1
};
const FixedSizeContainer = styled.div.withConfig({
  displayName: "PlayImage__FixedSizeContainer",
  componentId: "sc-58sj21-0"
})(["border-radius:", "px;background-color:", ";overflow:hidden;"], ({
  hasBorderRadius
}) => hasBorderRadius ? 2 : 0, Colors.GREY_2a2a2a);
export const imageBorderRadius = 2;
const calculateHeight = (width, aspectRatio) => `${Math.round(width / aspectRatioMap[aspectRatio])}px`;
// This is using the CSS intrinsic ratio scaling technique
// See: https://mademyday.de/height-equals-width-with-pure-css/
export const ExpandContainer = styled.div.withConfig({
  displayName: "PlayImage__ExpandContainer",
  componentId: "sc-58sj21-1"
})(["position:relative;border-radius:", "px;overflow:hidden;background-color:", ";img{position:absolute;top:0;left:0;width:100%;height:100%;display:block;}"], ({
  hasBorderRadius
}) => hasBorderRadius ? imageBorderRadius : 0, Colors.GREY_2a2a2a);
const ExpandingElement = styled.div.withConfig({
  displayName: "PlayImage__ExpandingElement",
  componentId: "sc-58sj21-2"
})(["height:0;width:100%;"]);
const getHeightPercentage = aspectRatio => `${100 / aspectRatioMap[aspectRatio]}%`;